export { default } from './RecentlyReturnedHistoryView';



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedHistoryView/index.js